import type { TaskView } from './client.ts';

/**
 * Open tasks by when they are due, in the browser's time zone: Overdue, Today (due later today),
 * Upcoming, No due date. My Tasks shows all four; Home shows the first two.
 */
export function groupByDue(
  tasks: TaskView[],
  now = Date.now(),
): Array<{ name: 'Overdue' | 'Today' | 'Upcoming' | 'No due date'; items: TaskView[] }> {
  const endOfToday = new Date(now);
  endOfToday.setHours(23, 59, 59, 999);
  const end = endOfToday.getTime();
  const due = (t: TaskView) => (t.dueAt ? Date.parse(t.dueAt) : NaN);
  return [
    { name: 'Overdue', items: tasks.filter((t) => due(t) < now) },
    { name: 'Today', items: tasks.filter((t) => due(t) >= now && due(t) <= end) },
    { name: 'Upcoming', items: tasks.filter((t) => due(t) > end) },
    { name: 'No due date', items: tasks.filter((t) => !t.dueAt) },
  ];
}
